import React from "react";
import {  Card, Loader, Grid, Button, Modal } from "semantic-ui-react";
import { dispatch } from "@rematch/core/";
import { withRouter } from 'react-router-dom';
import { singleLineText, multiLineText } from "../../../../common/RegexValidation";
import { Form, Dropdown } from 'formsy-semantic-ui-react';

import ImageResizer from "../../../../drive/ImageResizer/ImageResizer";
import { toastr } from 'react-redux-toastr';

import { history } from "../../../../../helpers";
const defaultLogo = "https://res.cloudinary.com/aspenify-prod/image/upload/v1630925914/Logo/logo-500.png";
    
    class GlobalEmailForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            updatedImage: props.globalTemplate && props.globalTemplate.picture ? props.globalTemplate.picture : props.selectedAccount.logo ? props.selectedAccount.logo : defaultLogo,
            
        }
    }
    
    async componentWillMount() {
       await dispatch.customTemplates.fetchGlobalTemplate();
       const { globalTemplate } = this.props;
       if (globalTemplate && globalTemplate.picture) {
           this.setState({ updatedImage: globalTemplate.picture });
       }
    }

    cloudinaryImage = (imageData) => {
        this.setState({ loader: true })
        if (imageData && imageData.data) {
            this.setState({ updatedImage: imageData.data.secure_url, loader: false })
        }
    }

    handleChangeTileImage = () => {
        let randomImageNumber = Math.floor(Math.random() * 10) + 1
        let imgUrl = "https://res.cloudinary.com/" + this.props.envData.cloudName + "/image/upload/Cards/playbook/" + randomImageNumber + ".png";
        this.setState({ updatedImage: imgUrl })
    }

    openImageModal = (open) => {
        this.setState({ open: open })
    }

    onSubmitGlobalTemplate = (data) => {
        data.picture = this.state.updatedImage;
        dispatch.customTemplates.addGlobalTemplate(data);
       
    }

    cancel = () => {
        let message = <div className="confirmMessage">
            <h3>Global Email Template</h3>
            <p>Global email template is not saved yet. Do you want to save it?</p>
        </div>;
        toastr.confirm(message, {
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => {
                this.form.submit();
            },
            onCancel: () => {  
                history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_wsSetting/emailTemplates/listing`)
            },
        });
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;

        return (
            <div>
                <div style={{ margin: "0 0 10px 0" }}>Global Email Template </div>
                
                <Form noValidate
                    ref={ref => this.form = ref}
                    className="formcyForm"
                    name="globalTemplate"
                    id="globalTemplateID"
                    onValidSubmit={(event) => { this.onSubmitGlobalTemplate(event) }}
                >
                    <Grid>
                        <Grid.Row className="addGlobalTemplate">
                            {/* from email */}
                            <Grid.Column width={10}>
                                <Form.Input
                                    name="fromEmail"
                                    id="fromEmail"
                                    label="From Email"
                                    value = {this.props.globalTemplate.fromEmail}
                                    validations="isEmail"
                                    errorLabel={errorLabel}
                                    validationErrors={{ isEmail: 'Email not valid' }}
                                    instantValidation
                                    autoFocus
                                />
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <Form.Input
                                    
                                    name="header"
                                    id="header"
                                    label="Header"
                                    value = {this.props.globalTemplate.header}
                                    validations={{ matchRegexp: singleLineText }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                        isDefaultRequiredValue: 'Header is required',
                                    }}
                                    instantValidation
                                    autoFocus
                                />

                            </Grid.Column>
                            <Grid.Column width={5}>
                                {/* <label>Hero Image</label> */}
                                <div style={{ "paddingTop": "5px" }}>
                                    <Card className="organizationCard" >
                                        <Card.Content >
                                            <div >
                                                <Loader active={this.state.loader} />
                                                <img src={this.state.updatedImage} className="fitImage object-fit-scale-down" alt="Custom Notification Image" />
                                                <Button type="button" className="circular_24_icon second-rectangle-image" icon='refresh' onClick={this.handleChangeTileImage} />
                                                <Button type="button" className="circular_24_icon first-rectangle-image" icon='pencil' onClick={() => this.openImageModal(true)} />
                                            </div >
                                        </Card.Content>
                                    </Card>
                                    <ImageResizer
                                        image={this.state.updatedImage}
                                        openImageModal={this.openImageModal}
                                        cloudinaryImage={this.cloudinaryImage}
                                        open={this.state.open}
                                        envData={this.props.envData}
                                        width={504}
                                        height={280}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="addGlobalTemplate">
                            <Grid.Column width={10}>
                                <Form.TextArea
                                    
                                    name="footer"
                                    label="Footer"
                                    id="footer"
                                    value = {this.props.globalTemplate.footer}
                                    errorLabel={errorLabel}
                                    validations={{ matchRegexp: multiLineText }}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 512. No space allowed in starting.',
                                        
                                    }}
                                    instantValidation
                                />

                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="addGlobalTemplate">
                            <Grid.Column width={10}>
                                <Form.TextArea
                                    
                                    name="signature"
                                    label="Signature"
                                    id="signature"
                                    value={this.props.globalTemplate.signature}
                                    errorLabel={errorLabel}
                                    validations={{ matchRegexp: multiLineText }}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 512. No space allowed in starting.',
                                        
                                    }}
                                    instantValidation
                                />

                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="pad_0">
                            <Grid.Column width={14} className="actionInFormcy border-none pad_0" >
                                <Button floated='right' id="savebtn" className="button-submit" type="submit">Save</Button>
                                <Button floated='right' className="button-cancel" id="cancelbtn" onClick={(e) => { e.preventDefault(); this.cancel(); }} >Cancel</Button>
                            </Grid.Column>
                        </Grid.Row>

                    </Grid>
                </Form>
            </div>
        );
    }
}

export default withRouter(GlobalEmailForm);
